export default __webpack_public_path__ + "static/media/noCover.58e008e5.png";